module.exports = __webpack_public_path__ + "static/media/login.5730884a.svg";